import * as z from 'zod';

import { iconFiles } from './icon-files.ts';

export const IconNames = z.enum(iconFiles);
export type IconNames = z.infer<typeof IconNames>;

export const legacyIconMap: Record<string, IconNames> = {
  'activity-heart': 'heart-circle',
  'alert-hexagon': 'alert-circle',
  'annotation-heart': 'heart',
  'bank-note-02': 'bank-note-01',
  'bank-note': 'bank-note-01',
  'book-open-02': 'book-open-01',
  'briefcase-01': 'briefcase-02',
  'building-02': 'building-01',
  'building-06': 'building-01',
  'check-heart': 'heart-circle',
  'christ-centered': 'christ',
  'clock-fast-forward': 'clock',
  'cloud-lightning': 'cloud-raining-03',
  'coins-01': 'coins-02',
  'coins-stacked-01': 'coins-02',
  'currency-dollar-circle': 'currency-dollar',
  'droplets-02': 'droplets-01',
  'file-heart-03': 'file-heart-01',
  'file-heart': 'file-heart-01',
  'globe-02': 'globe-05',
  'graduation-hat-01': 'graduation-hat-02',
  'heart-hexagon': 'heart-circle',
  'home-02': 'home-03',
  'home-04': 'home-03',
  'line-chart-up': 'line-chart-up-02',
  'luggage-02': 'luggage-03',
  'medical-cross': 'medical',
  'medical-square': 'medical',
  'message-chat': 'message-chat-circle',
  'message-question': 'message-question-circle',
  'monitor-04': 'monitor-01',
  'piggy-bank-02': 'piggy-bank-01',
  'pin-01': 'marker-pin-01',
  'scales-02': 'scales-01',
  'shield-02': 'shield-01',
  'trophy-01': 'award-01',
  compass: 'compass-03',
  gift: 'gift-01',
  glasses: 'glasses-02',
  globe: 'globe-05',
  hearts: 'heart',
  home: 'home-03',
  rss: 'rss-01',
  scales: 'scales-01',
  user: 'user-01',
};
export const IconNamesSafe = z.string().transform((icon) => {
  if (!IconNames.options.includes(icon as IconNames)) {
    if (legacyIconMap[icon]) {
      // console.error(
      //   `Swapping missing icon "${icon}" with "${legacyIconMap[icon]}"`,
      // );
      return IconNames.parse(legacyIconMap[icon]);
    }
    console.error(
      `Can't find valid icon replacement for missing icon "${icon}"`,
    );
    // If the icon is missing, display an alert, to draw attention of editors.
    return IconNames.enum['alert-circle'];
  }
  return IconNames.parse(icon);
});
export type IconNamesSafe = z.infer<typeof IconNames>;
